import { Card } from 'antd';
import styled from 'styled-components';

export const ChartCard = styled(Card)<{ shouldScroll: boolean }>`
    height: 100%;
    min-height: 380px;
    overflow-y: ${(props) => (props.shouldScroll ? 'scroll' : 'hidden')};
`;
